<!DOCTYPE html>
<template>
<div class="generic">
  <section class="anchor" id="jumbo">
  </section>

  <b-jumbotron bg-variant="primary"
               text-variant="light"
               header="Job Security for Cybersecurity Jobs"
               lead="We’re building cybersecurity's best talent marketplace,
               connecting independent contractors with technology leaders.">
    <b-button variant="success"
              @click="whyUs"
              class="shadow-lg">Why Us?</b-button>
  </b-jumbotron>

  <br>
  <br>

  <section class="anchor" id="whyUs">
    <div>

      <h2>Why choose BlueTeam?</h2>
      <p>
      Traditional consulting firms burden FinTechs with unskilled resources and mountains of paperwork to operate with a flexible workforce.
      At the same time, consultants who do the work are underpaid, overburdened, and unsupported.
      </p>
    </div>
    <b-card class="shadow-lg"
            no-body>
      <h1>Easy</h1>
      <h2>Effortlessly describe your project, and find the best person for the job.</h2>
      <b-button variant="primary"
                @click="verified"
                class="shadow-lg">Learn how</b-button>
    </b-card>
  </section>

  <section class="anchor" id="verified">
    <b-card bg-variant="light"
            text-variant="primary"
            no-body>
      <VerificationBadge :status="true"
                         large
                         simple />
      <h1>Verified</h1>
      <h2>Finding and assessing cybersecurity professionals is hard. We know how to help.</h2>
    </b-card>

    <div>
      <h2>We know security.</h2>
      <p>
        Every candidate is personally interviewed by a cybersecurity professional. We use work history, certifications, and references to help match you with the right candidate for every job.
      </p>
      <b-button variant="primary"
                @click="fast"
                class="shadow-lg">See results</b-button>
    </div>
  </section>


  <section class="anchor" id="fast">
    <div>
      <h2>Onboard 3x Faster</h2>
      <p>
        Don't waste time assessing talent, scoping projects and negotiating contract details. Our custom project onboarding allows us to scope every project for you, and our Universal MSA™ lets you sign once and onboard as many professionals as you need.
      </p>
      <b-button class="shadow-lg"
                variant="primary"
                @click="getStarted">
        Get started
      </b-button>
    </div>
    <b-card bg-variant="light"
            class="shadow-lg"
            text-variant="primary"
            no-body>
      <h1>Fast</h1>
      <h2>Why screen candidates yourself? Pick from our pool of experts instead.</h2>
    </b-card>

  </section>


</div>
</template>

<script>
import VerificationBadge from '@/components/VerificationBadge'
export default {
  name: 'About',
  components: { VerificationBadge },
  metaInfo() {
    return {
      title: 'About',
      meta: [
        { name: "description", content: "About" },
        { name: "twitter:title", content: "BlueTeam - About", vmid: 'twitter:title' },
        { name: "og:image", content: "https://getblueteam.com/img/BlueTeamLogo.bb7395fa.png" },
        { name: "twitter:description", content: 'Vetted cybersecurity talent for Fintech & Digital Health', vmid: 'twitter:description' },
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }
  },
  data() {
    return {}
  },
  props: {},
  computed: {},
  methods: {
  whyUs() {
    window.location.hash = ''
    window.location.hash = 'whyUs'
  },
  verified() {
    window.location.hash = ''
    window.location.hash = 'verified'
  },
  fast() {
    window.location.hash = ''
    window.location.hash = 'fast'
  },
  getStarted() {
    if ( this.$router.history.current.path == '../home' ) {
      window.location.hash = ''
      window.location.hash = 'onboarding'
    } else {
      this.$router.push( '/home#onboarding' ).catch( () => {} )
    }
  }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";

.generic {
    color: theme-color-level('primary', 0);
}

</style>
